import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { mainPageQueries } from '@/services/mainPage/mainPage.queries';
import { useSearch } from '@tanstack/react-router';

export const useMainpageGroupList = () => {
  const search = useSearch({ from: '/(app)/recommendation-management/main-page/' });
  const { page, fetch, q, locationId } = search;
  const { data, isFetched, isLoading } = useQuery({
    ...mainPageQueries.list({
      row: page,
      fetch: fetch,
      search: q,
      locationId,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    mainPageGroup: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
